export const palettes = {
    Blue: {
        mainColor: "#1a1afb",
        lighterVariant: "#4868b3",
    },
    Red: {
        mainColor: "#960529",
        lighterVariant: "#a84747",
    },
    Green: {
        mainColor: "#228B22",
        lighterVariant: "#98FB98",
    },
    Yellow: {
        mainColor: "#FFDB58",
        lighterVariant: "#FFFF99",
    },
    Purple: {
        mainColor: "#68217e",
        lighterVariant: "#70577c",
    },
    Orange: {
        mainColor: "#CC5500",
        lighterVariant: "#FFDAB9",
    },
    Brown: {
        mainColor: "#3D1C02",
        lighterVariant: "#D2B48C",
    },
    Pink: {
        mainColor: "#FF00FF",
        lighterVariant: "#FFB6C1",
    },
    Gray: {
        mainColor: "#36454F",
        lighterVariant: "#C0C0C0",
    },
    Teal: {
        mainColor: "#008080",
        lighterVariant: "#40E0D0",
    },
};
